"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConstants = void 0;
const nativeModule_1 = require("../nativeModule");
const getConstants = () => nativeModule_1.nativeModule.getConstants();
exports.getConstants = getConstants;
